import api from '../api/axios';

const getAllGuarantees = (skip = 0, take = 1000000, withDeleted) => {
  const response = api.get(
    `/guarantee?skip=${skip}&take=${take}&sort=deletedAt%2Cdesc&sort=id%2Casc&withDeleted=${withDeleted}`,
  );

  return response;
};

const getGuaranteeById = (id) => {
  const response = api.get(`/guarantee/${id}`);

  return response;
};

const create = (item) => {
  const response = api.post(`/guarantee`, item);

  return response;
};

const update = (id, updatedItem) => {
  const response = api.patch(`/guarantee/${id}`, updatedItem);

  return response;
};

const remove = (id) => {
  const response = api.delete(`/guarantee/${id}`);

  return response;
};

const restore = (id) => {
  const response = api.get(`/guarantee/${id}/restore`);

  return response;
};

const search = (skip = 0, take = 1000000, query, widthDeleted = false, options = {}) => {
  const response = api.get(`/guarantee?skip=${skip}&take=${take}&sort=deletedAt%2Cdesc&query=${query}`, {
    ...options,
  });

  return response;
};

const fileImport = (newFile) => {
  const response = api.post(
    '/guarantee/import',
    {
      file: newFile,
    },
    {
      headers: { accept: 'application/json', 'Content-Type': 'multipart/form-data' },
    },
  );

  return response;
};

const fileExport = () => {
  const response = api.get(`/guarantee/export`);

  return response;
};

const guaranteeServices = {
  getAllGuarantees,
  getGuaranteeById,
  create,
  update,
  remove,
  restore,
  search,
  fileImport,
  fileExport,
};

export default guaranteeServices;

